import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, X } from "lucide-react";
import { useState } from "react";

const DISMISS_KEY = "seopilot_trial_banner_dismissed_until";

export default function TrialBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => {
    try {
      const t = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
      return t && Date.now() < t;
    } catch (e) { return false; }
  });

  if (!user || !user.on_trial || dismissed) return null;
  const days = user.trial_days_remaining ?? 0;
  const urgent = days <= 2;

  const dismissForToday = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now() + 8 * 3600 * 1000));
    } catch (e) { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div
      className={`border-b ${urgent ? "bg-amber-50 border-amber-300" : "bg-primary text-background border-foreground"}`}
      data-testid="trial-banner"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm">
          <Sparkles className={`w-4 h-4 ${urgent ? "text-amber-700" : ""}`} />
          <span className="font-mono-data text-[11px] uppercase tracking-widest">
            {urgent ? "Trial ending" : "Pro trial"}
          </span>
          <span className={urgent ? "text-amber-900" : ""}>
            <strong>{days === 0 ? "Today" : `${days} day${days === 1 ? "" : "s"}`} left</strong> · Magic Mode, AI sections, multi-platform social, auto-schedule.
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/pricing">
            <button className={`text-xs font-mono-data uppercase tracking-widest px-3 py-1.5 border ${
              urgent
                ? "border-amber-700 text-amber-900 hover:bg-amber-100"
                : "border-background/40 hover:bg-background/10"
            }`} data-testid="trial-banner-cta">
              Keep Pro →
            </button>
          </Link>
          <button onClick={dismissForToday} className="opacity-70 hover:opacity-100" data-testid="trial-banner-dismiss" aria-label="Dismiss">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
